export const generateComputedWithEmit = (value = 'value', event = 'input') => ({
  get () {
    return this[value]
  },
  set (value) {
    this.$emit(event, value)
  }
})

export const generateComputedWithMethod = (value = 'value', method) => ({
  get () {
    return this[value]
  },
  set (value) {
    this[method](value)
  }
})
